import {
    Container,
    Grid,
} from "@material-ui/core"
import { Fragment, useEffect } from "react"
import HomePage from "../../Home"
import { useDispatch } from "react-redux"
import { obtenerVuelosProveedorAllAction } from "../../../ducks/proveedorAereolineaDuck"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import TProveedoresVuelos from "../TProveedorVuelos"
import FProveedoresVuelos from "../FProveedorVuelos"
import FCircuitosVuelo from "../FCircuitosVuelo"
const useProvedorVuelos = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerVuelosProveedorAllAction()).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
}
const VProveedorAereos = () => {
    useProvedorVuelos()
    return (
        <Fragment>
            <Container maxWidth="xl" style={{marginTop: "2rem"}}>
                <Grid item xs={12}>
                    <FProveedoresVuelos />
                </Grid>
                <Grid item xs={12}>
                    <TProveedoresVuelos />
                </Grid>
                <FCircuitosVuelo />
            </Container>
        </Fragment>
    )
}
export default VProveedorAereos